<template>
    <label class="base-input text-input" :class="type">
        <span v-if="showLabel" v-text="label"></span>
        <input type="text" v-model="value"/>
        <span v-if="showHint" class="base-input-desc" v-text="hint"></span>
    </label>
</template>

<script>
    import BaseInput from "./BaseInput.js";

    export default {
        name: "TextInput",
        mixins: [BaseInput],
        props: {
            hint: {
                type: String,
                default: '',
            }
        },
        computed: {
            showHint() {
                return this.hint.length > 0;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../scss/base-input";
</style>